import classNames from 'classnames';
import {ComponentChildren} from 'preact';
import backArrowIcon from '@/icons/back-arrow-icon-2.svg';
import nextArrowIcon from '@/icons/next-arrow-icon.svg';

export default function SteppedButtonGroup({
  label,
  nextClassName,
  nextIcon = nextArrowIcon,
  onNextStep,
  onPreviousStep,
  previousClassName,
  previousIcon = backArrowIcon,
  showPreviousButton = true,
  disabled = false,
}: SteppedButtonGroupProps) {
  function handleClickPrevious() {
    onPreviousStep && onPreviousStep();
  }

  function handleClickNext() {
    onNextStep && onNextStep();
  }

  return (
    <div
      className={classNames('grid h-max', {
        'grid-cols-max-grow gap-x-3': showPreviousButton,
        'grid-cols-1': !showPreviousButton,
      })}
    >
      {showPreviousButton && (
        <button
          className={classNames(
            'btn flex items-center justify-center p-0',
            previousClassName ?? 'btn-neutral btn-outline h-16 w-16'
          )}
          onClick={handleClickPrevious}
        >
          <img
            alt="Back button icon"
            className="h-6 w-auto"
            height="24"
            loading="lazy"
            src={previousIcon}
            width="24"
          />
        </button>
      )}
      <button
        className={classNames('btn w-full', nextClassName ?? 'btn-lg btn-lime')}
        disabled={disabled}
        onClick={handleClickNext}
        // Test id should be used to bind analytics events
        data-testid={
          showPreviousButton ? `buy-stack-add-to-cart` : `buy-stack-next-step`
        }
      >
        <span className="grid-cols-grow-max grid items-center justify-items-center">
          {label}
          {nextIcon && (
            <img
              alt="Next button icon"
              className="h-6 w-auto"
              height="24"
              loading="lazy"
              src={nextIcon}
              width="24"
            />
          )}
        </span>
      </button>
    </div>
  );
}

export type SteppedButtonGroupProps = {
  disabled?: boolean;
  label: string | ComponentChildren;
  nextClassName?: string;
  nextIcon?: string | null;
  onNextStep?: () => void;
  onPreviousStep?: () => void;
  previousClassName?: string;
  previousIcon?: string;
  showPreviousButton?: boolean;
};
